var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    directives: [
      {
        name: "waypoint",
        rawName: "v-waypoint",
        value: { active: _vm.Global.activeWp, callback: _vm.BottomWaypoint },
        expression: "{ active: Global.activeWp, callback: BottomWaypoint }",
      },
    ],
    staticClass: "bottom-waypoint",
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }